export default "__VITE_ASSET__CmQqJ8FN__"